import enumFactory from "@util/enumFactory";

export default enumFactory.createEnum({

    NORMAL: {
        code: 1,
        title: '正常'
    },
    FORBIDDEN: {
        code: 2,
        title: '已禁用'
    },
    EXPIRE: {
        code: 3,
        title: '已过期'
    },

});
